import React, { useEffect, useState } from 'react'
import './Navbar.css'
import Logo from '../../images/g-dragon-logo-sq.png'
import { Row, Col, Modal, Button } from 'antd';
import { useWeb3React } from '@web3-react/core'
import { getEllipsisTxt } from '../../helpers/Formatter'
import { Copy, ExternalLink, CheckCircle } from 'react-feather'
import SocialsLinks from './SocialsLinks'
import { Link } from 'react-router-dom';
import Metamask from '../../images/metamask.png'
import TrustWallet from '../../images/trust_wallet.png'
import { toast, ToastContainer } from 'react-toastify';
import { InjectedConnector } from '@web3-react/injected-connector'
import { WalletConnectConnector } from '@web3-react/walletconnect-connector'

function Navbar() {

    // const state = useContext(GlobalState)
    const [connectWallet, setConnectWallet] = useState(false)
    const [isLoggedUserModalVisible, setIsLoggedUserModalVisible] = useState(false)
    const [addressCopy, setAddressCopy] = useState(false)
    const { account, deactivate, activate } = useWeb3React()
    const [isLoginLoading, setIsLoginLoading] = useState(false)

    const handleOkLogin = () => {
        setConnectWallet(false);
    };

    const handleCancelLogin = () => {
        setConnectWallet(false);
    };

    useEffect(() => {
        console.log('account is loading ', isLoginLoading)
    }, [isLoginLoading])

    const handleConnect = () => {
        setConnectWallet(true)
    }

    const handleLoggedUserInfoModal = () => {
        setIsLoggedUserModalVisible(true)
    }

    const handleOk = () => {
        setIsLoggedUserModalVisible(false)
    };

    const handleCancel = () => {
        setIsLoggedUserModalVisible(false)
    };

    const handleDisconnect = async () => {
        try {
            window.localStorage.removeItem("userData")
            deactivate()
            handleCancel()
        } catch (error) {
            console.error("error while logout from user ", error)
        }
    }

    const copyAddress = () => {
        setAddressCopy(true)
        navigator.clipboard.writeText(account)
    }

    const handleMetamaskConnect = async () => {
        try {
            //check the chain id is supported or not
            if (window.ethereum) {
                if (window.ethereum.networkVersion === '56' || window.ethereum.networkVersion === '97' || window.ethereum.networkVersion === '250') {
                    setIsLoginLoading(true)
                    await activate(injected)
                    const loginPayload = {
                        provider: 'injected',
                        isLoggedIn: true
                    }
                    window.localStorage.setItem('userData', JSON.stringify(loginPayload))
                } else {
                    toast.error('Wrong Network! Please switch to the BSC network')
                    return
                }
            }
        } catch (error) {
            const loginPayload = {
                provider: 'injected',
                isLoggedIn: false
            }
            window.localStorage.setItem('userData', JSON.stringify(loginPayload))
            console.error('error connecting to metamask ', error)
            let errorMessage = 'Something went wrong! please try again'
            if (error && error.message) {
                errorMessage = error.message
            }
            toast.error(errorMessage)
        } finally {
            setIsLoginLoading(false)
            setConnectWallet(false)
        }
    }

    const handleTrustWalletConnect = async () => {
        try {
            setIsLoginLoading(true)
            await activate(wcConnector)
            const loginPayload = {
                provider: 'walletconnect',
                isLoggedIn: true
            }
            window.localStorage.setItem('userData', JSON.stringify(loginPayload))
        } catch (error) {
            const loginPayload = {
                provider: 'walletconnect',
                isLoggedIn: false
            }
            window.localStorage.setItem('userData', JSON.stringify(loginPayload))
            console.error('error connecting to wallet-connect ', error)
            let errorMessage = 'Something went wrong! please try again'
            if (error && error.message) {
                errorMessage = error.message
            }
            toast.error(errorMessage)
        } finally {
            setIsLoginLoading(false)
            setConnectWallet(false)
        }
    }

    const POLLING_INTERVAL = 3000
    const injected = new InjectedConnector({ supportedChainIds: [56, 97, 1, 250] })
    const wcConnector = new WalletConnectConnector({
        rpc: {
            56: "https://bsc-dataseed1.binance.org"
        },
        network: "binance",
        qrcode: true,
        qrcodeModalOptions: {
            mobileLinks: [
                "metamask",
                "trust"
            ]
        },
        pollingInterval: POLLING_INTERVAL
    })
    wcConnector.networkId = 56

    useEffect(() => {
        if (account) {
            toast.success('You have been logged in')
        }
    }, [account])

    return (
        <div>
            <Row>
                <Col xs={24} sm={24} md={18} lg={18} xl={18}>
                    <div className="d-flex justify-content-start align-items-start">
                        {
                            account ? (
                                <button className="btn btn-outline-connect" onClick={handleLoggedUserInfoModal}>
                                    <img
                                        alt='logged-user-icon'
                                        src={Logo}
                                        style={{ width: '20px', marginRight: '5px' }} />
                                    {getEllipsisTxt(account, 6)}
                                </button>
                            ) : (
                                <div className='hiring-dragon-button-container mx-5 mt-4'>
                                    <Button
                                        block
                                        className='hiring-dragons-btn'
                                        type="primary"
                                        shape="round"
                                        onClick={handleConnect}
                                        size="small">
                                        Connect Wallet
                                    </Button>
                                </div>
                                // <button className="btn btn-outline-connect" onClick={handleConnect}>Connect Wallet</button>
                            )
                        }
                    </div>
                </Col>

                <Col xs={12} sm={12} md={3} lg={3} xl={3} className='mt-4'>
                    <div className='d-flex justify-content-between'>
                        <Link to={'/'}>
                            <button className="btn btn-outline-navbar">
                                Mining APP
                            </button>
                        </Link>
                        <Link to={'/nft-listing'}>
                            <button className="btn btn-outline-navbar">
                                NFT
                            </button>
                        </Link>
                    </div>

                </Col>
                <Col xs={12} sm={12} md={3} lg={3} xl={3}>
                    <div className='socials-hidden-mobile'>
                        <SocialsLinks />
                    </div>
                </Col>
            </Row>

            <Modal title="CONNECT YOUR WALLET" visible={connectWallet} onOk={handleOkLogin} onCancel={handleCancelLogin} footer={null} >
                <div className='hiring-dragon-button-container my-3'>
                    <Button
                        block
                        className='hiring-dragons-btn'
                        type="primary"
                        shape="round"
                        size="large"
                        onClick={handleMetamaskConnect}>
                        <img
                            alt='metamask'
                            src={Metamask}
                            style={{ width: '25px', marginTop: '-5px', marginRight: '10px' }} />
                        Metamask
                    </Button>
                </div>
                <div className='hiring-dragon-button-container my-3'>
                    <Button
                        block
                        className='hiring-dragons-btn'
                        type="primary"
                        shape="round"
                        size="large"
                        onClick={handleTrustWalletConnect}>
                        <img
                            alt='trust-wallet'
                            src={TrustWallet}
                            style={{ width: '25px', marginTop: '-5px', marginRight: '10px' }} />
                        Trust Wallet
                    </Button>
                </div>
            </Modal>

            <Modal title="Connected User Details"
                visible={isLoggedUserModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                footer={null} >

                <div className="row">
                    <p className="text-muted fw-bold col-9 hide-on-mobile">Connected with Metamask</p>
                    <p className="text-end col-md-3 col-sm-6 fw-bold text-green user-disconnect-btn" onClick={handleDisconnect}>
                        Disconnect
                    </p>
                </div>

                <button
                    className="btn btn-lg col-12 text-light fw-bold text-start mb-2 connected-user-model-button"
                    style={{ fontSize: '16px' }}>
                    <img
                        alt='connected-user'
                        src={Logo}
                        style={{ width: '20px', marginRight: '15px' }} />
                    {getEllipsisTxt(account, 10)}
                </button>

                <div className="row mt-3">
                    {!addressCopy && <p className="col-lg-4 col-md-6 col-sm-6 text-green fw-bold" onClick={copyAddress}>
                        <Copy size={18} color="rgba(45,100,206)" />
                        <span style={{ marginLeft: '5px' }}>Copy address</span></p>}
                    {addressCopy && <p className="col-lg-4 col-md-6 col-sm-6 text-green fw-bold"><CheckCircle size={18} color="rgba(45,100,206)" /><span style={{ marginLeft: '5px' }}>Copied</span></p>}
                    <a href={`https://bscscan.com/address/${account}`} target="_blank" className="col-lg-4 col-md-6 col-sm-6 text-green fw-bold" rel="noreferrer"><ExternalLink size={18} color="rgba(45,100,206)" /><span style={{ marginLeft: '5px' }}>View on explorer</span></a>
                </div>

            </Modal>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                style={{ textAlign: 'start' }}
                theme="dark"
                limit={2}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </div>
    )
}

export default Navbar
